export default {
  ICIMApi: {
    getIMToken: 'api/IMServerCommon/getIMToken',
    getChartInfo: 'api/IMServerCommon/getChartInfo',
    getIMList: 'api/IMServerCommon/getIMList',
    getIMHistory: 'api/IMServerCommon/getIMHistory',
    getIMUsers: 'api/IMServerCommon/getIMUsers',
    getIMConsultantPortrait: 'api/IMServerCommon/getIMConsultantPortrait',
    // 获取聊天关键词
    getKeyWords: 'api/IMServerCommon/getKeyWords',
    //获取咨询人的所有聊天
    getConsultantAllIMHistory: 'api/IMServerCommon/getIMHistory',
    sendMessage: 'api/IMServerCommon/sendMessage',
    finishService: 'api/IMServerCommon/finishService',
    quickReplies: 'api/IMServerCommon/quickReplies',
    satisfactionLog: 'api/IMServerCommon/satisfactionLog',
    // changeIMLawyerStatus: 'api/IMServerCommon/changeIMLawyerStatus',
    submitTag: 'api/IMServerCommon/submitTag',
    getRiskLevels: 'api/IMServerCommon/getRiskLevels',
    getTagOptions: 'api/IMServerCommon/getTagOptions',
    getEmojiSeries: 'api/IMServerCommon/getEmojiSeries',
    getEmojiSeriesItem: 'api/IMServerCommon/getEmojiSeriesItem',
    getAllEmojiSeriesItems: 'api/IMServerCommon/getAllEmojiSeriesItems',
    changeIntelligentAssistance: 'api/IMServerCommon/changeIntelligentAssistance',
    findConsultantHisChart: 'api/IMServerCommon/findConsultantHisChart',
    getTelHis: '/api/hotlineApi/getHotlineHis',
    getOfflineHis: '/api/offline/getList',
    // 修改咨询件业务类型
    modifyDicSpecialty: '/api/IMServerCommon/modifyDicSpecialty',
    // 修改咨询类型
    modifyConsultationType: '/api/IMServerCommon/modifyConsultationType',
    getLawyerOptions: '/api/IMServerCommon/getLawyerOptions',
    //抢单大厅的接口
    grabbingHallApi: {
      // 获取等待抢单列表
      getWaitingList: 'api/grabbingHall/getWaitingList',
      // 抢单操作
      grabbingConsultation: 'api/grabbingHall/grabbingConsultation',
      // 获取当前可抢单的律师列表
      getAssignLawyers: 'api/grabbingHall/getAssignLawyers',
      // 指派
      assignConsultation: 'api/grabbingHall/assignConsultation'
    },
    consultantApi: {
      getOngoingList: 'api/consultantApi/getOngoingList',
      getFinishedList: 'api/consultantApi/getFinishedList',
      exportFinished: 'api/consultantApi/exportFinished',
      getFirstMessage: 'api/consultantApi/getFirstMessage',
      interposeConsultant: 'api/consultantApi/interposeConsultant',
      exportFinishedZip: 'api/consultantApi/exportFinishedZip',
    },
    adviceApi: {
      getAdviceList: 'api/advice/getAdviceList',
      submitHandle: 'api/advice/submitHandle'
    },
    statisticsApi: {
      getList: 'api/statisticsApi/getList',
      exportData: 'api/statisticsApi/exportData'
    },
    //配置相关
    config: {
      addBlackList: 'api/imConfig/addBlackList',
      examineBlackList: 'api/imConfig/examineBlackList',
      getBaseConfig: 'api/imConfig/getBaseConfig',
      updateIMConfig: 'api/imConfig/updateIMConfig',
      clearIMToken: 'api/imConfig/clearIMToken',
      getMessageExtraOptions: 'api/imConfig/getMessageExtraOptions',
      getQuickReplyList: 'api/imConfig/getQuickReplyList',
      saveOrUpdateQuickReply: 'api/imConfig/saveOrUpdateQuickReply',
      delQuickReply: 'api/imConfig/delQuickReply',
      getConsultantInfoList: 'api/imConfig/getConsultantInfoList',
      getBlackList: 'api/imConfig/getBlackList',
      saveBlackList: 'api/imConfig/saveBlackList',
      updateBlackList: 'api/imConfig/updateBlackList',
      delBlackList: 'api/imConfig/delBlackList',
      getBlackTypes: 'api/imConfig/getBlackTypes',
      getSensitiveWordList: 'api/imConfig/getSensitiveWordList',
      getSensitiveWordInterceptLog: 'api/imConfig/getSensitiveWordInterceptLog',
      exportSensitiveWordInterceptLog: 'api/imConfig/exportSensitiveWordInterceptLog',
      saveOrUpdateSensitiveWord: 'api/imConfig/saveOrUpdateSensitiveWord',
      delSensitiveWord: 'api/imConfig/delSensitiveWord',
      saveOrUpdateTag: 'api/imConfig/saveOrUpdateTag',
      getTagdList: 'api/imConfig/getTagList',
      delTag: 'api/imConfig/delTag',
      // 咨询人列表
      getConsultantInfoPageList: 'api/imConfig/getConsultantInfoPageList',
      getTestList: 'api/imConfig/getTestList',
      delTest: 'api/imConfig/getTestList',
      saveOrUpdateTest: 'api/imConfig/saveOrUpdateTest',
    },
    // 表情配置相关
    emojiConfig: {
      getSeries: 'api/emojiConfig/getEmojiSeries',
      saveOrUpdateEmojiSeries: 'api/emojiConfig/saveOrUpdateEmojiSeries',
      delSeries: 'api/emojiConfig/delSeries',
      getSeriesItems: 'api/emojiConfig/getEmojiSeriesItems',
      saveOrUpdateEmojiItem: 'api/emojiConfig/saveOrUpdateEmojiItem',
      delSeriesItems: 'api/emojiConfig/delSeriesItems',

    },
    noticeGroupApi: {
      getImConfig: 'api/noticeGroupApi/getImConfig',
      getNoticeGroups: 'api/noticeGroupApi/getNoticeGroups',
      delNoticeGroups: 'api/noticeGroupApi/delNoticeGroups',
      getGroupUsersOptions: 'api/noticeGroupApi/getGroupUsersOptions',
      saveOrUpdateNoticeGroup: 'api/noticeGroupApi/saveOrUpdateNoticeGroup',
      getGroupUsers: 'api/noticeGroupApi/getGroupUsers',
      delGroupUsers: 'api/noticeGroupApi/delGroupUsers',
      saveGroupUsers: 'api/noticeGroupApi/saveGroupUsers',
      initGroup: 'api/noticeGroupApi/initGroup',
      userGroupList: 'api/noticeGroupApi/userGroupList'
    }
  }
}
